export class DashboardService {
  http;

  constructor(http) {
    this.http = http;
  }

  async fetch() {
    return this.http.get('/portfolios/admin-details');
  }
}
